import { render, staticRenderFns } from "./ActivityWsImageButton.vue?vue&type=template&id=23ba352c&scoped=true"
import script from "./ActivityWsImageButton.vue?vue&type=script&lang=ts"
export * from "./ActivityWsImageButton.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsImageButton.vue?vue&type=style&index=0&id=23ba352c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba352c",
  null
  
)

/* custom blocks */
import block0 from "./ActivityWsImageButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports